import { GEMINI_API_URL } from '@/src/constants/endpoints';

// Create endpoints for Home Moves API
export const HOME_MOVES_ENDPOINTS = {
  createMoveOut: (accountId: string) =>
    `${GEMINI_API_URL}/home-moves/${accountId}/move-out`,

  updateMoveOutDate: (accountId: string) =>
    `${GEMINI_API_URL}/home-moves/${accountId}`,

  cancelMoveOut: (accountId: string) =>
    `${GEMINI_API_URL}/home-moves/${accountId}`,

  fetchMoveOutStatus: (accountId: string) =>
    `${GEMINI_API_URL}/home-moves/${accountId}/status`,

  retrieveHomeMovesCustomer: (accountId: string) =>
    `${GEMINI_API_URL}/home-moves/${accountId}`,
};
